<template>   
  <div class="col-md-12">
    <barra-navegacao :visiblebutton="true"/>
    <b-row class="text-center">
        <b-col cols="12">          
          <div style="margin-bottom:10px"></div>
             <b-col lg="12" class="my-1">
              <b-form-group
                label="Pesquisar"
                label-for="filter-input"
                label-cols-sm="3"
                label-align-sm="right"
                label-size="sm"
                class="mb-0"
              >
                <b-input-group size="sm">
                  <b-form-input
                    id="filter-input"
                    v-model="filter"
                    type="search"
                    placeholder="Descrição ou Identificador"
                  ></b-form-input>

                  <b-input-group-append>
                    <b-button :disabled="!filter" @click="filter = ''">Limpar</b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
            <div style="margin: 10px"></div>
              <b-card bg-variant="light" style="min-height: 60vh;">
                <div class="col-md-12">                   
                    <div class="overflow-auto">
                      <b-table stacked="md" id="table-parametros" @filtered="onFiltered" :filter="filter" :filter-included-fields="filterOn" striped small :fields="fields" :items="parametros" responsive="sm" :per-page="perPage" :current-page="currentPage">
                        
                        <template v-slot:cell(acoes)="data">
                            <b-button @click="visualizar(data.item)" class="v-button" size="sm" style="background-color: #303f9f; margin-right: 5px" title="Editar"><b-icon icon="pencil"></b-icon></b-button>
                        </template>

                      </b-table>
                      <div style="float: right">
                        <b-pagination
                        size="sm"
                        v-model="currentPage"
                        :total-rows="rows"
                        :per-page="perPage"
                        aria-controls="table-parametros"
                        ></b-pagination>
                      </div>                      
                    </div>
                </div>
              </b-card>
              <br>
        </b-col>
      </b-row>
      
      <!-- Modal Formulário Parâmetro -->
      <b-modal id="modal-parametro" ref="modal" title="Editar Parâmetro" @hidden="resetModal" @ok="salvar" ok-title="Salvar" cancel-title="Cancelar">
        <template v-if="parametro">
          <b-form-group label="Identificador" label-for="identificador-input">
              <b-form-input id="identificador-input" v-model="parametro.identificador" disabled></b-form-input>
          </b-form-group>

          <b-form-group label="Descrição" label-for="descricao-input">
              <b-form-textarea id="descricao-input" v-model="parametro.descricao" rows="3" placeholder="Descrição do parâmetro..."></b-form-textarea>
          </b-form-group>

          <b-form-group label="Valor" label-for="valor-input">
              <b-form-input id="valor-input" v-model="parametro.valor" placeholder="Ex: 10, true, ativo..."></b-form-input>
          </b-form-group>
        </template>
      </b-modal>
  </div>
</template>

<script>
import BarraNavegacao from '@/components/BarraNavegacao.vue'
import ParametroService from '@/services/ParametroService.js'

export default {
  components: {
    BarraNavegacao,
  },
  data() {
    return {
      parametro: {
          idParametro: null,
          identificador: '',
          descricao: '',
          valor: ''
      },
      parametros: [],
      fields: [
        { key: 'idParametro', label: 'ID', sortable: true },
        { key: 'identificador', label: 'Identificador', sortable: true },
        { key: 'descricao', label: 'Descrição', sortable: true },
        { key: 'valor', label: 'Valor', sortable: true },
        { key: 'acoes', label: 'Ações' }
      ],
      perPage: 10,
      currentPage: 1,
      rows: 0,
      filter: null,
      filterOn: ['descricao', 'identificador'],
    }
  },

  created(){
    this.listarParametros();
  },

  methods: {
    alertaMensager(mensagem, titulo, tipo){
          this.$fire({
              title: titulo,
              text: mensagem,
              type: tipo,
          });
    },

    salvar(bvModalEvent){
        bvModalEvent.preventDefault();

        let payload = {
            descricao: this.parametro.descricao,
            valor: this.parametro.valor
        };

        if (this.parametro.idParametro) {
            ParametroService.atualizar(this.parametro.idParametro, payload).then((res) => {
                if (res.status === 203) {
                    this.alertaMensager(res.data, "Erro", "error");
                } else {
                    this.alertaMensager("Parâmetro atualizado com sucesso!", "", "success");   
                    this.listarParametros();
                    this.$refs.modal.hide();
                }
            }).catch(() => {
                this.alertaMensager("Erro ao atualizar parâmetro no servidor.", "Erro", "error");
            });
        }
    },

    resetModal() {
        this.parametro = {
          idParametro: null,
          identificador: '',
          descricao: '',
          valor: ''
        };
    },

    visualizar(item){
        this.parametro = { ...item };
        this.$refs.modal.show();
    },

    listarParametros(){
        ParametroService.listarTodos().then(resposta => {
            this.parametros = resposta.data;
            this.rows = this.parametros.length;
        }).catch(() => {
            this.alertaMensager("Erro ao listar parâmetros", "Erro", "error");
        });
    },

    onFiltered(filteredItems) {
      this.rows = filteredItems.length;
      this.currentPage = 1;
    }
  }
}
</script>
